import { DashboardView } from "../view/dashboard";
import {connect} from "react-redux";

const DashboardContainer=connect()(DashboardView);
export default DashboardContainer;